import { z } from 'zod';
import { TRUE_FALSE } from './helpers/enums.ts';

export const listenUDPOffloadsSchema = z.enum([...TRUE_FALSE, '']);
export const listenUDPOffloadsRequiredSchema = listenUDPOffloadsSchema.refine((val) => val !== '', {
  message: 'Choose whether UDP offloads should be enabled',
});
